import {
  extractData,
  extractDataWithMeta,
} from "@shared/utils/extract-dto-data";
import { safeParseWithFallback } from "@shared/utils/safe-parse-with-fallback";

import { NewsArticlesDtoSchema, NewsPageDtoSchema } from "./schemas";
import type { NewsListType, NewsPageDtoType } from "./types";

const defaultMeta = {
  pagination: { page: 1, pageSize: 0, pageCount: 0, total: 0 },
};

export const mapDtoToArticles = (dto: unknown): NewsListType => {
  const parsed = safeParseWithFallback(
    NewsArticlesDtoSchema,
    dto,
    "mapDtoToArticles",
  );

  return extractDataWithMeta<NewsListType["data"], NewsListType["meta"]>(
    parsed,
    dto,
    defaultMeta as NewsListType["meta"],
  );
};

export const mapDtoToNewsPage = (dto: unknown): NewsPageDtoType => {
  const parsed = safeParseWithFallback(
    NewsPageDtoSchema,
    dto,
    "mapDtoToNewsPage",
  );

  return extractData(parsed, dto, dto as NewsPageDtoType);
};
